module.exports = __webpack_public_path__ + "img/comissao.2e80c636.svg";